/** Product constants shared by the Worker, the client and the tests. */

/** A two-person room cannot provide meaningful privacy (spec §5). */
export const MIN_PARTICIPANTS = 3;
/** V1 ceiling (spec §6.2). */
export const MAX_PARTICIPANTS = 30;

export const MAX_TITLE_LENGTH = 80;

export const DAY_MS = 24 * 60 * 60 * 1000;

/** An open room lives at most 7 days. */
export const OPEN_ROOM_TTL_MS = 7 * DAY_MS;
/** A revealed result lives 7 further days, then the whole room is deleted. */
export const REVEALED_ROOM_TTL_MS = 7 * DAY_MS;

/**
 * If a reveal is claimed but never finishes (Worker eviction mid-transaction), the
 * claim may be retaken after this long. See BUILD_CONTRACT.md decision D6.
 */
export const REVEAL_CLAIM_TIMEOUT_MS = 30_000;

/** Room id: 128 bits of entropy, base64url encoded. */
export const ROOM_ID_BYTES = 16;
export const ROOM_ID_LENGTH = 22; // ceil(16 * 4 / 3), unpadded base64url

/** Admin secret: 256 bits. */
export const ADMIN_SECRET_BYTES = 32;
/** Participant token: 128 bits. */
export const PARTICIPANT_TOKEN_BYTES = 16;

/** Private route prefix. Room, result and manage all live here. */
export const ROOM_PATH_PREFIX = '/r/';

/** Fragment key carrying the creator's manage secret. */
export const MANAGE_FRAGMENT_KEY = 'manage';

export const RATE_LIMITS = {
  /** Room creation, per client, per minute. */
  createRoom: { limit: 5, windowSeconds: 60 },
  /** Room creation, per client, per day — stops slow-drip bot farms. */
  createRoomDaily: { limit: 40, windowSeconds: 86_400 },
  /** Response submits and edits, per client, per minute. */
  submitResponse: { limit: 20, windowSeconds: 60 },
  /** Admin actions, per client, per minute. */
  manage: { limit: 30, windowSeconds: 60 },
  /** First-party analytics beacons, per client, per minute. */
  event: { limit: 60, windowSeconds: 60 },
} as const;
